/**
 * <zh/> 扩展注册表
 *
 * <en/> Extension registry
 */
export const EXTENSION_REGISTRY = {
    animation: {},
    behavior: {},
    combo: {},
    edge: {},
    layout: {},
    node: {},
    palette: {},
    theme: {},
    plugin: {},
    transform: {},
    shape: {},
};
//# sourceMappingURL=store.js.map